import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';
import { Injectable } from '@angular/core';
import { IAutoDirectSetting } from '../interfaces/auto-direct-settings';
import { compare } from 'fast-json-patch';
import {
  IAutoDirectLog,
  IAutoDirectSummaryFilter,
  IAutoDirectSummaryResponse,
} from '../interfaces/auto-direct-summary';

@Injectable({
  providedIn: 'root',
})
export class AutoDirectService extends BaseDataService {
  url = '/api/autoDirect';
  entityTitle = 'AutoDirect Settings';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getSettings(): Promise<IAutoDirectSetting[]> {
    return this.handleRequest<IAutoDirectSetting[]>(
      this.http.get<IAutoDirectSetting[]>(this.url + '/settings'),
      this.handlersFactory.getForReadAll(),
    );
  }

  getSetting(id): Promise<IAutoDirectSetting> {
    return this.handleRequest<IAutoDirectSetting>(
      this.http.get<IAutoDirectSetting>(this.url + '/setting/' + id),
      this.handlersFactory.getForReadAll(),
    );
  }

  getSummary(filterCommand: IAutoDirectSummaryFilter): Promise<IAutoDirectSummaryResponse> {
    return this.handleRequest<IAutoDirectSummaryResponse>(
      this.http.get<IAutoDirectSummaryResponse>(this.url + '/summary', {
        params: this.constructHttpParams(filterCommand),
      }),
      this.handlersFactory.getForReadAll(),
      '',
    );
  }

  getLogs(autoDirectSummaryId: number): Promise<IAutoDirectLog[]> {
    return this.handleRequest<IAutoDirectLog[]>(
      this.http.get<IAutoDirectLog[]>(
        this.url + '/logs?autoDirectSummaryId=' + autoDirectSummaryId,
      ),
      this.handlersFactory.getForReadAll(),
      '',
    );
  }

  getNextRun(): Promise<string | null> {
    return this.handleRequest<string | null>(
      this.http.get<string | null>(this.url + '/nextRun'),
      this.handlersFactory.getForReadAll(),
    );
  }

  saveSetting({ autoDirectSetting }) {
    var settingUrl = this.url + '/setting';

    if (autoDirectSetting.id) {
      var newUrl = settingUrl + '/' + autoDirectSetting.id;
      var oldDTO = {};
      var patch = compare(oldDTO, autoDirectSetting);

      return this.handleRequest<any>(
        this.http.patch<IAutoDirectSetting>(newUrl, patch),
        this.handlersFactory.getForUpdate(this.entityTitle),
      );
    } else {
      return this.handleRequest<any>(
        this.http.post<IAutoDirectSetting>(settingUrl, autoDirectSetting),
        this.handlersFactory.getForCreate(this.entityTitle),
      );
    }
  }
}
